/* eslint-disable import/prefer-default-export */
export const DEFAULT_ASSET_LOCATION = {
  latitude: 39.5,
  longitude: -98.35,
};



// WEBPACK FOOTER //
// ./src/compositions/CaseDealerLocatorClosedPanel/constants.js